import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../utils/classNames';
import './index.scss';

export default function CountChip({
    children,
    pulse = false,
    className = '',
    ...rest
}) {
    return (
        <span className={classNames('count-chip', className)} {...rest}>
            {pulse ? <span className="count-chip__pulse" aria-hidden="true" /> : null}
            <span className="count-chip__label">{children}</span>
        </span>
    );
}

CountChip.propTypes = {
    children: PropTypes.node.isRequired,
    pulse: PropTypes.bool,
    className: PropTypes.string,
};
